const structureItemData = [
  {
    imageUrl: '/assets/images/Beton-plot.png',
    label: 'BETON OU PLOT BETON',
    showCheckbox: true,
  },
  {
    imageUrl: '/assets/images/slide-3 copy.png',
    label: 'SOL MEUBLE TASSE',
    showCheckbox: true,
  },
]


const structureInstallation = [
  {
    image: "/assets/images/Capture_copy.png",
    name: 'Feutre géotextile',
    checkbox: false,
  },
  {
    image: '/assets/images/4381249 copy 2.png',
    name: 'Mon sol est déjà prêt',
    checkbox: false,
  },
]

export {structureItemData, structureInstallation}